class ApiError extends Error {
  constructor(message, status, substatus, data) {
    super(message);
    this.name = "ApiError";
    this.status = status;
    this.substatus = substatus;
    // The parsed (already camelCased) response body. Preserved so a caller can read a structured error
    // payload — e.g. a server `code` and an ATS-provided message — that this boundary would otherwise
    // discard, leaving only the HTTP status.
    this.data = data;
  }
}

class SemanticError extends Error {
  constructor(message) {
    super(message);
    this.success = false;
    this.name = "SemanticError";
  }
}

class RequestCanceledError extends Error {
  constructor(message = "Request canceled") {
    super(message);
    this.name = "RequestCanceledError";
    this.code = "ERR_CANCELED";
  }
}

export const isRequestCanceled = error => {
  return (
    error instanceof RequestCanceledError ||
    error?.name === "RequestCanceledError" ||
    error?.name === "CanceledError" ||
    error?.code === "ERR_CANCELED"
  );
};

export default ApiError;
export { RequestCanceledError, SemanticError };

export const handleApiError = error => {
  if (error.name == "CanceledError" || error.code === "ERR_CANCELED") {
    throw new RequestCanceledError(error.message);
  }
  if (error.response) {
    if (error.response.status === 422 && error.response.data) {
      throw new SemanticError(error.response.data.message);
    } else if (error.response.status === 401) {
      throw new ApiError("Unauthorized", error.response.status, "");
    } else {
      const errorMessage = `${error.response.status}: ${error.response.statusText}`;
      throw new ApiError(errorMessage, error.response.status, error.response.data?.substatus || "", error.response.data);
    }
  } else {
    throw new ApiError(`${error.reason || error.message}`);
  }
};
